import React, { Component } from 'react';
import {Typography} from '@hpi-sox/hpstellar-core';

import { withStaticContent } from '../../../ui/components/static-content';
import './disclaimer.less';

const disclaimer = props => {
    return (
        <div className="blog-disclaimer">
            <Typography variant="bodyXS">
                <em>
                    <Typography variant="boldXS" tag="span">
                        Disclosure:
                    </Typography>{' '}
                    Our site may get a share of revenue from the sale of the products featured on this page.
                </em>
            </Typography>
        </div>
    );
};

export default withStaticContent(disclaimer);
